import {
  TTranslationAppearanceForm,
  TTranslationAppearanceTheme,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  colorTheme: {
    label: 'Farbschema',
    tooltip: 'Legt die Farben von Qmulus fest. Jede Vorschau zeigt das Farbschema in der gewählten Dichte.',
  },
  density: {
    label: 'Dichte',
    tooltip: 'Legt fest, wie viel Abstand Qmulus zwischen Elementen lässt. Kompakt zeigt mehr Inhalt auf einmal, weit gibt den Elementen mehr Raum.',
  },
  locale: {
    label: 'Sprache',
    tooltip: 'Ermöglicht es, die gewünschte Sprache und des Gebietsschemas für die Benutzeroberfläche auszuwählen.',
  },
  fontSize: {
    label: 'Skalierung',
    tooltip: 'Ermöglicht die Größe von Schrift und Bedienelement anzupassen.',
  },
  chartTimeFormat: {
    label: 'Zeitformat für Diagramme',
    tooltip: 'Legt fest, wie Daten und Zeitstempel auf der X-Achse der Diagramme angezeigt werden.',
  },
  unitSystem: {
    label: 'Einheitensystem',
    tooltip: 'Wählen Sie Ihre bevorzugten Messeinheiten (z. B. metrisch oder imperial) zur Anzeige der Werte aus.',
  },
  scaleOption: {
    label: 'Layout Skalierung',
    tooltip: 'Legt fest, wie die Skalierung des Shop-Layouts dargestellt werden soll.',
  },
  showOnlyAvailableApps: {
    label: 'Nur verfügbare Apps anzeigen?',
    tooltip: 'Blendet Apps aus, die nicht zur Verfügung stehen, um die Benutzeroberfläche übersichtlicher zu gestalten.',
  },
  hasOptedOutOfReleaseHighlights: {
    label: 'Neuerungen nach Updates anzeigen?',
    tooltip: 'Zeigt nach einem Update einmalig die Neuerungen neuer Qmulus-Versionen. Sie sind jederzeit auf der Seite verfügbar, die sich beim Klick auf die Versionsnummer im Benutzermenü öffnet.',
  },
};

const appearanceTheme: TTranslationAppearanceTheme = {
  colorThemeOption: {
    'qmulus-light': 'Qmulus Hell',
    'qmulus-g10': 'Qmulus Grau 10',
    'qmulus-g90': 'Qmulus Grau 90',
    'qmulus-dark': 'Qmulus Dunkel',
    'aichelin-light': 'Aichelin Hell',
    'aichelin-dark': 'Aichelin Dunkel',
    'pt9000-modern': 'PT9000 Modern',
    'pt9000': 'PT9000',
    'galaxy-desert': 'Galaxy Wüste',
    'galaxy-snow': 'Galaxy Schnee',
    'galaxy-void': 'Galaxy Leere',
    'galaxy-ember': 'Galaxy Glut',
  },
  densityOption: {
    compact: 'Kompakt',
    regular: 'Normal',
    wide: 'Weit',
  },
};

export default {
  subline: 'Ändere das Erscheinungsbild von Qmulus.',
  appearanceForm,
  appearanceTheme,
};
